export interface CryptoPrice {
  BTC: number;
  ETH: number;
  SOL: number;
}

export interface PricingPlan {
  name: string;
  price: string;
  period: string;
  cryptoPrice: CryptoPrice;
  planId: string;
  isPopular?: boolean;
  description?: string;
}

/** Single public offer — backend plan id unchanged for checkout */
export const DEFAULT_PRICING_PLANS: PricingPlan[] = [
  {
    name: 'Atlas Pass',
    price: '600€',
    period: '30 days · private compute lane',
    description: 'Semi-dedicated Ryzen 9 · 16 cores · 48 GB RAM · 10 Gbps',
    cryptoPrice: { BTC: 0.005899, ETH: 0.181804, SOL: 6.35391 },
    planId: 'starter-monthly',
    isPopular: true,
  },
];

export const ATLAS_PASS_PLAN = DEFAULT_PRICING_PLANS[0];
